<template>
    <div class="sidebar">
        <div class="sidebar-backdrop" @click="closeSidebarPanel" v-if="isPanelOpen"></div>
        <transition name="slide">
            <div v-if="isPanelOpen"
                 class="sidebar-panel"
                 >
                <slot ></slot>
            </div>
        </transition>
    </div>
</template>
<script>
import { store, mutations } from '@/store/store.js'

export default {
    methods: {
        closeSidebarPanel: mutations.toggleNav
    },
    computed: {
        isPanelOpen() {
            return store.isNavOpen
        }
    }
}
</script>
<style>
ul li a {
  color: white !important;
}
    .slide-enter-active,
    .slide-leave-active
    {
        transition: transform 0.2s ease;
    }

    .slide-enter,
    .slide-leave-to {
        transform: translateX(-100%);
        transition: all 150ms ease-in 0s
    }

    .sidebar-backdrop {
        background-color: rgba(0,0,0,.5);
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        cursor: pointer;
        z-index: 50;
    }

    .sidebar-panel {
        overflow-y: auto;
        background-color: black;
        position: fixed;
        left: 0;
        top: 0;
        height: 100vh;
        z-index: 999;
        padding: 3rem 20px 2rem 20px;
        width: 300px;
    }
    .sidebar-panel-nav li a:hover {
        color: #36a8eb !important;
    }
    .sidebar-panel-nav li  {
        padding: 8px 0 8px 0;
        border-bottom: 1px solid white;
    }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue